<div class="creative-card" (click)="onClick()">
  <div class="card-header">
    <div class="brand-header">
    <img *ngIf="brandLogoUrl" class="brand-logo" [src]="brandLogoUrl" [alt]="card.brandName">
    <span class="brand-name" [title]="card.brandName">{{ card.brandName }}</span>
    </div>
    <app-platform-icons [platforms]="card.platforms"></app-platform-icons>
  </div>
  <app-media-thumbnail
    [thumbnailUrl]="thumbnailUrl"
    [isVideo]="card.mediaType === 'video'"
    [altText]="card.brandName">
  </app-media-thumbnail>
  <span class="creative-description" *ngIf="card.description">{{ card.description}}</span>
</div>
